import { render } from "./MobileMenuItemWithChildren.vue?vue&type=template&id=ae05d9d2"
import script from "./MobileMenuItemWithChildren.vue?vue&type=script&lang=js"
export * from "./MobileMenuItemWithChildren.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__